module.exports = __webpack_public_path__ + "web_static/img/about_hkstp1.0f8ea172.png";